export default "__VITE_ASSET__Bxxo77xy__"